export default function isUserExperienceTest() {
    if (typeof navigator !== 'undefined' && navigator.userAgent.match('ZD-ProductionTest')) {
        return true;
    } else {
        return false;
    }
}
